
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var objLogoutForm = null;
var objTopHeaderButtonSignout = null;

// Page load finished
window.addEventListener('load', function () {
	objTopHeaderButtonSignout = document.getElementById("topHeaderButtonSignout");
	objLogoutForm = document.getElementById("frmAppLogout");

	// Add event listener to signout button
	if (objTopHeaderButtonSignout) {
		objTopHeaderButtonSignout.addEventListener("click", logout, false);
	}
});

function logout(evt) {
	evt.preventDefault();

	if (confirm(this.dataset.confirmMsg)) {
		objLogoutForm.submit();
		return true;
	}
	return false;
}
